import { Button } from '@progress/kendo-vue-buttons';
/**
 * Represents the default `toggleButton` component.
 */

var ToggleButton = Button;
var ToggleButtonVue3 = ToggleButton;
export { ToggleButton, ToggleButtonVue3 };